import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "../../Footer/Footer";
import { StyledMain } from "./Layout.styled";
import { Loader } from "../../Loader/Loader";

export const Layout = () => {
	return (
		<StyledMain>
			<Suspense fallback={<Loader margin="margin" />}>
				<Outlet />
			</Suspense>
			<Footer />
		</StyledMain>
	);
};
